<template>
  <div>
    <div class="d-flex align-items-center mr-2">
      <div class="header-button" @click="confirmAndGoBack()">
        <chevron-left-icon size="18"/>
      </div>
      <h1 class="page-title">{{ title }}</h1>
      <div v-if="bilanType || operationType" class="d-flex ">
        <span v-if="bilanType" :class="{'bilan-exe':bilanType==='EXE','bilan-avp':bilanType==='AVP'}"
              class="bilanType-vignette">{{ `Bilan ${bilanType}` }}</span>
        <span v-if="operationType"
              class="operationType-vignette">{{$t(`operation.type.enum.${operationType.toLowerCase()}`)}}</span>
      </div>
    </div>
    <div v-if="subTitleOpe" class="page-subtitle-ope">
      {{ subTitleOpe }}
    </div>
    <div v-if="subTitle" class="page-subtitle">
      {{ subTitle }}
    </div>
  </div>

</template>

<script>

import i18n from '../../i18n'

export default {
  name: 'BackArrow',

  components: {
    i18n
  },

  props: {
    title: {
      type: String,
      default: i18n.t('Back')
    },
    confirm: {
      type: Boolean,
      default: false
    },
    routeBack: {
      type: String,
      default: null
    },
    subTitle: {
      type: String,
      default: null
    },
    subTitleOpe: {
      type: String,
      default: null
    },
    params: {
      type: Object,
      default: function () {
        return {}
      }
    },
    bilanType: {
      type: String,
      default: null,
      required: false
    },
    operationType: {
      type: String,
      default: null,
      required: false
    },
  },
  methods: {
    confirmAndGoBack() {
      if (this.confirm) {
        this.$confirm(this.$i18n.t('Back.confirm').toString()).then(() => {
          this.$store.commit('setUnsavedChanges', false);
          this.goBack()
        });
      } else {
        this.goBack();
      }
    },
    goBack() {
      if (this.routeBack) {
        this.$router.push({
          name: this.routeBack,
          params: this.params
        })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped>
.header-button-line {
  flex-direction: row;
}

.header-button {
  display: inline-block;
  background-color: var(--main-color);
  border-radius: var(--main-border-radius);
  height: 24px;
  width: 24px;
  margin-right: 1em;
  color: white;
}

.header-button svg {
  height: 24px;
  width: 24px;
}

.header-button:hover {
  cursor: pointer;
  background-color: var(--main-color-hover);
  color: var(--main-white);
}

.page-title {
  font-size: 2rem;
}

.bilanType-vignette {
  color: var(--main-white);
  text-align: center;
  font-family: Montserrat, "Arial", sans-serif;
  letter-spacing: 1px;
  border-radius: 4px;
  opacity: 1;
  padding: 4px 8px;
  margin-left: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  font-size: 12px;
}

.operationType-vignette {
  color: var(--main-color-text);
  text-align: center;
  font-family: Montserrat, "Arial", sans-serif;
  letter-spacing: 1px;
  border-radius: 4px;
  opacity: 1;
  padding: 4px 8px;
  margin-left: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  font-size: 12px;
  border: 2px solid var(--main-color);
  background-color: transparent;

}

</style>



// WEBPACK FOOTER //
// src/components/b122/BackArrow.vue